import { connect } from 'react-redux';
import View from './AdviserGetStartedView';
import { userSelector, endpointsSelector } from '../App/AppSelector';
import {
  sampleClientsSelector,
  showFinancialPlanningSelector,
  showStartPageSelector,
} from '../AdviserArea/AdviserAreaSelector';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = state => ({
  user: userSelector(state),
  endpoints: endpointsSelector(state),
  sampleClients: sampleClientsSelector(state),
  showStartPage: showStartPageSelector(state),
  portalName: selectPortalName(state),
  showFinancialPlanning: showFinancialPlanningSelector(state),
});

export default connect(mapStateToProps)(View);
